export default {
  BAndRText: "图书与评论",
  Srchbook: "按图书搜索",
  offlisugg: "Ofellio的建议 ",
  recentlyRated: "最近评价",

  // Reveiw Page
  rewbtn1: "想读",
  rewbtn2: "写评论",
  rewbtn3: "用于图书双人组",
  rateBook: "评价这本书",
  buyon: "购买于",
  Read: "阅读",
  reviewtext: "评论",
  ratingtext: "您的评分",
  readon: "阅读于",
  book: "图书",
  ebook: "电子书",
  audiobook: "有声书",
  revTitle: "评论标题",
  submitbtn: "提交",

  // Book Duo Page
  yourbd: "您的图书双人组",
  serchbook: "搜索图书",
  DidText: "找不到您的图书？请输入详细信息！",
  city: "城市",
  type: "类型",
  lookigfr: "寻找",
  male: "男性",
  female: "女性",
  idk: "无所谓",
  agerg: "年龄范围",
  language: "语言",
  detil: "详细信息 ",
  optnal: "可选",
  lookiginsp: "寻找灵感",
  suggbokduo: "图书双人组推荐图书",
  seemoresugg: "查看更多建议",
  bokcvr: "图书封面 ",
  title: "标题",
  writer: "作者 ",
  genre: "类型 ",
  upload: "上传 ",
  add: "添加 ",
  online: "在线",
  onlink: "添加视频通话链接（Teams、Zoom、Google Meet等）",
  noBookSelected: "未选择图书",
  loading: "加载中...",
  noResultsFound: "未找到结果",
  meetingLink: "会议链接",
  noLimit: "无限制",
  languageTooltip: "这是参与者在Book Duo期间将使用的语言。",
  languageTooltipBookClub: "这是参与者在Book Club期间将使用的语言。",
  updating: "更新中...",
  publishing: "发布中...",
  update: "更新",
  noBooksFound: "在此1:1建议下未找到图书。",
  wellDone: "做得好！",
  bookDuoLive: "您的Book Duo现已上线。",
  willInformInterest: "当有人表示兴趣时，我们会通知您！",
  seeOn: "查看",
  map: "地图",

  // Book Club Page
  when: "何时",
  time: "时间 ",
  age: "年龄",
  publsbtn: "发布 ",
  day: "日",
  month: "月份 ",
  year: "年",
  hour: "小时",
  min: "分钟",
  max: "最大",
  selectTime: "选择时间",
  selectLanguage: "选择语言",
  selectType: "选择类型",
  inPerson: "面对面",
  attendees: "参与者",
  eventDetails: "活动详情",

  // Silent Reading Page
  where: "地点",
  venue: "场地",
  address: "地址",

  // BookAnd Review page Event
  welc: "欢迎",
  memb: "成员",
  exploreText: "探索并加入可用活动，创建您自己的活动。",
  sbybooks: "图书 ",
  month: "月份 ",
  sortby: "排序方式",
  cbduo: "创建图书双人组",
  smoreevent: "查看更多活动",
  dowant: "您想创建自己的活动吗？",
  ledAmbsdr: "图书俱乐部和静读会由Ambassador领导。",
  bAnAmbsdor: "成为Ambassador  ",
  leadText: "领导一个或探索并加入",
  evtnear: "您附近可用的活动。",
  BookDuoFirstText: `您正在寻找个人联系吗？图书双人组非常适合您！`,
  BookDuoSecondText: `寻找个人联系？选择一本书，选择合作伙伴的年龄和性别偏好，开始一对一的文学之旅。`,

  BookClubFirstText: `在您所在地区或在线发现图书俱乐部，在舒适的场所举办，如咖啡馆、酒吧或欢迎的场所，或通过视频会议。`,
  BookClubSecondText: `加入在舒适环境中举办的欢迎式面对面或在线图书俱乐部。每个小组由Ambassador协助，确保活跃和包容的体验。`,

  BookSilentFirstText: `在轻松舒适的环境中举行，静读会为最多10位读者提供宁静的避风港。`,
  BookSilentSecondText: `享受宁静的静读会。带上您自己的书，放松，并分享一起阅读的安静乐趣。`,

  DuoBtnText: `创建图书双人组`,
  ClubBtnText: `创建图书俱乐部`,
  SilentBtnText: `创建静读会`,
  bookDuoTitle: "图书双人组",
  bookClubTitle: "图书俱乐部",
  bookSilentTitle: "Silent Reading",

  // BOOK_CLUB DUO SILENTREADING
  yownbook: "您自己的书",
  resetFilters: "重置筛选",
  resetAll: "全部重置",
  applyFilters: "应用筛选",
  filters: "筛选",
  full: "已满",
  booksCover: "图书封面",
  writerLabel: "作者",
  genreLabel: "类型",
  aboutTheBookLabel: "关于这本书",
  addButton: "添加",
  booked: "已预订",
  open: "开放",
  buyon: "购买于",
  gender: "性别",
  locatedin: "位于",
  aboutbook: `关于这本书`,
  readmore: `阅读更多 `,
  readless: `阅读更少 `,
  details: "详细信息",
  totalspot: "总名额",
  spotleft: "剩余名额",
  join: "加入",
  share: "分享",
  cregistration: "完成注册",
  registrationmsg: "您的电子邮件地址将与Ambassador共享 ",
  welldone: "做得好！",
  attending: "您正在参加 ",
  attendmsg:
    "您现在可以在Ofellio仪表板中查看此活动并与您的Ambassador聊天",
  thankyou: "谢谢！",
  thankmsg:
    "组织者现在知道您的兴趣，可能会向您发送消息以安排此图书双人组的详细信息",
  // CHAT PAGE
  msgtext: "消息 ",
  vprofile: "仪表板",
  mute: "静音",
  block: "屏蔽",
  unblock: "取消屏蔽",
  report: "举报",
  cancelR: "取消",

  // Setting Page
  pprofile: "个人资料",
  accnotifi: "账户通知",
  uploadp: "上传照片",
  name: "姓名",
  surname: "姓氏",
  dob: "出生日期",
  aboutme: "关于我",
  country: "国家",
  favgenre: "喜爱的类型",
  asmedia: "在下方添加您的社交媒体",
  savechgbtn: "保存更改",

  cypass: "更改您的密码",
  cypasstext:
    "当您更改密码时，您将从其他会话中自动退出",
  cpass: "更改密码",
  cyemail: "更改您的电子邮件",
  cyemailtext:
    "当您更改电子邮件时，您将从其他会话中自动退出",
  cemail: "更改电子邮件",
  notifi: "通知 ",
  emailmeab: "通过电子邮件通知我",
  lastesttext: "最新热门图书",
  upcomtext: "下个月的新书",
  baevent: "我会喜欢的图书、作者和活动 ",
  newoff: "新的Ofellio功能",
  leadin: "我正在领导",
  curnpass: "当前密码",
  newpass: "新密码",
  cnewpass: "确认新密码",
  curnemail: "当前电子邮件",
  newemail: "新电子邮件",
  cnewemail: "确认新电子邮件",
  delyacc: "删除您的账户 ",
  sorrytext: "很抱歉您想离开我们！",
  suretext: "您确定要这样做吗？ ",
  decitext:
    "如果您决定再次使用Ofellio，您需要创建一个新账户。",
  pass: "密码",

  // meun
  jan: "一月",
  feb: "二月",
  mar: "三月",
  apr: "四月",
  may: "五月",
  jun: "六月",
  jul: "七月",
  aug: "八月",
  sep: "九月",
  oct: "十月",
  nov: "十一月",
  dec: "十二月",
  // Month abbreviations
  monthAbbrJan: "1月",
  monthAbbrFeb: "2月",
  monthAbbrMar: "3月",
  monthAbbrApr: "4月",
  monthAbbrMay: "5月",
  monthAbbrJun: "6月",
  monthAbbrJul: "7月",
  monthAbbrAug: "8月",
  monthAbbrSep: "9月",
  monthAbbrOct: "10月",
  monthAbbrNov: "11月",
  monthAbbrDec: "12月",
  cri: "犯罪",
  fic: "小说",
  grpnvl: "图像小说与漫画",
  yng: "青少年与LGBTQ+",
  nonfic: "非小说",
  scifan: "科幻与奇幻",
  others: "其他",
  morerec: "最近",
  lessrec: "最早 ",

  // HeaderProfil
  setg: "设置 ",
  logout: "退出",

  // dashbords pages
  editprf: "编辑资料",
  cbduo: "创建图书双人组",
  joining: "我正在参加",
  bandrew: "图书与评论 ",

  upcomclub: "即将举行的图书俱乐部",
  upcomduo: "即将举行的图书双人组",
  upcomsil: "即将举行的静读会",
  allpst: "所有过去的活动 ",
  edit: "编辑",
  canc: "取消RSVP",
  going: "参加",
  ngoing: "不参加 ",
  cancel: "取消",

  level: "级别",
  cbclub: "创建图书俱乐部",
  cbsil: "创建静读会 ",
  loyprog: "忠诚度计划",
  mang: "管理",
  attlist: "参与者列表",
  event: "取消RSVP",

  chatgroup: "与小组聊天",
  chatambas: "与Ambassador聊天",

  bookshelv: "Sally的书架",
  reviews: "评论",

  // Leading Page
  ambassador: "Ambassador",
  member: "成员",
  level1: "级别1",
  level2: "级别2",
  level3: "级别3",
  level4: "级别4",
  toLevel: "到",
  highestLevel: "🎉 您已达到最高级别！",
  editProfile: "编辑资料",
  createBookClub: "创建图书俱乐部",
  createSilentReading: "创建静读会",
  createBookDuo: "创建图书双人组",
  createEvent: "+ 创建活动",
  attendeesList: "参与者列表",
  edit: "编辑",
  cancel: "取消",
  wantToRead: "想读",
  read: "阅读",
  remove: "删除",
  tbd: "待定",
  full: "已满",
  yourOwnBook: "您自己的书",
  ageLabel: "年龄：",
  manage: "管理",
  cancelRSVP: "取消RSVP",
  imLeading: "我正在领导",
  imJoining: "我正在参加",
  booksAndReviews: "图书与评论",
  loyaltyProgram: "忠诚度计划",
  upcomingBookClubs: "即将举行的图书俱乐部",
  upcomingSilentReadings: "即将举行的静读会",
  upcomingBookDuos: "即将举行的图书双人组",
  noEventsToShow: "没有要显示的活动。",
  wantToReadLower: "想读",
  readLower: "阅读",
  reviewsLower: "评论",
  noRatedBooks: "您还没有评价任何图书。",
  giftsDiscounts: "阅读礼品和折扣",
  loyaltyDescription: "您读得越多，赢得越多！随着级别的提升，享受折扣和福利。",
  starterReader: "初级读者",
  starterReaderDesc: "开始您作为OfellioAmbassador的旅程，开始领导您的第一次阅读体验。",
  starterReaderReward: "早期认可和访问未来Ambassador福利。",
  communityBuilder: "社区建设者",
  communityBuilderDesc: "继续连接读者并在您的社区内创建引人入胜的图书活动。",
  communityBuilderReward: "优先访问新功能和独家更新。",
  proHost: "专业主持人",
  proHostDesc: "您正在塑造有意义的阅读时刻，并通过您的活动激励他人。",
  proHostReward: "受邀参加即将举行的Ofellio倡议和特别惊喜。",
  legend: "传奇",
  legendDesc: "继续激励世界各地的读者 — 您的领导力塑造了Ofellio社区。",
  legendReward: "解锁独家认可和不断发展的福利。",
  attendees: "参与者",
  noAttendeesYet: "还没有参与者。",
  chatWithGroup: "与小组聊天",
  cancelEvent: "取消活动",
  cancelRSVPConfirm: "您确定要取消您的RSVP吗？",
  cancelEventConfirm: "您确定要取消此活动吗？",
  cancelRSVPEmail: "将向Ambassador发送取消电子邮件。",
  cancelEventEmail: "将向当前参与者发送取消电子邮件。",

  // How It Works Section
  howOfellioWorks: "Ofellio如何工作",
  howItWorksDesc: "发现通过图书连接的新方式 — 一对一、小组或宁静的静读会。",
  bookDuoTitle: "图书双人组",
  bookDuoDesc: "寻找个人联系？选择一本书，选择合作伙伴的年龄和性别偏好，开始一对一的文学之旅。",
  bookClubTitle: "图书俱乐部",
  bookClubDesc: "加入在舒适环境中举办的欢迎式面对面或在线图书俱乐部。每个小组由Ambassador协助，确保活跃和包容的体验。",
  silentReadingTitle: "Silent Reading",
  silentReadingDesc: "享受宁静的静读会。带上您自己的书，放松，并分享一起阅读的安静乐趣。",
  exploreThe: "探索",
  existingEvents: "现有活动",
  or: "或",
  createYourOwn: "创建您自己的",
  joinOfellio: "加入Ofellio",
  signUp: "注册",
  chooseYourCountry: "选择您的国家",
  joined: "已加入",
  joinedCapitalized: "已加入",
  shareThisEvent: "分享此活动",
  linkVisibleAttendees: "链接仅对参与者可见",
  recentReviews: "最近评论",
  noReviewsAvailable: "没有可用评论",
  writeAReview: "写评论",
  yourRating: "您的评分",
  update: "更新",
  aboutTheBook: "关于这本书",
  makeAChoiceForThisBook: "为此书做出选择",
  howDidYouReadIt: "您是如何阅读的？",
  noRating: "无评分",
  reviewPublished: "评论已发布",
  useForBookDuo: "用于图书双人组",
  yourReview: "您的评论",
  addAShortTitle: "添加简短标题",
  shareYourThoughts: "分享您对此书的想法...",
  send: "发送",
  bookclubLive: "做得好！您的图书俱乐部现已上线，人们可以加入。",
  silentReadingLive: "做得好！您的静默阅读现已上线，人们可以加入。",
  dashboard: "仪表板",
  
  // Day abbreviations
  dayMon: "周一",
  dayTue: "周二",
  dayWed: "周三",
  dayThu: "周四",
  dayFri: "周五",
  daySat: "周六",
  daySun: "周日",

  // Notification translations
  sentYouAMessage: "给您发了一条消息！",
  justJoinedYour: "刚刚加入了您的",
};

